<template>
    <b-modal
        title="Dados para contato"
        size="xl"
        v-model="open"
        header-bg-variant="orange"
        hide-header
        centered
        hide-footer>
        <div>
            <!-- <h1>{{}} - Detalhes do lojistas {{}}</h1> -->
            <hr>
            <div>
                <div>
                    <h2>Razão Social</h2>
                    <p>{{}}</p>
                    <h2>RG</h2>
                    <p>{{}}</p>
                    <h2>E-mail</h2>
                    <p>{{}}</p>
                </div>

                <div>
                    <h2>Nome Fantasia</h2>
                    <p>{{}}</p>
                    <h2>CPF</h2>
                    <p>{{}}</p>
                    <h2>Celular / Whatsapp</h2>
                    <p>{{}}</p>
                </div>

                <div>
                    <h2>Nome Reponsável</h2>
                    <p>{{}}</p>
                    <h2>CNPJ</h2>
                    <p>{{}}</p>
                    <h2>Telefone</h2>
                    <p>{{}}</p>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    name: 'ContactShopkeeper',

    data() {
        return {
            open: false,
        }
    },

    methods: {
        toggleOpen() {
            this.open = !this.open
        },
    }
}
</script>